import React from 'react';
import { Button, ButtonProps } from '@fluentui/react-components';
import { OpenRegular } from '@fluentui/react-icons';

type EnhancedButtonProps = ButtonProps & {
  isExternal?: boolean
};

const EnhancedButton: React.FC<EnhancedButtonProps> = (props) => {
  const { isExternal = false, ...restProps } = props;

  const finalIcon = isExternal ? <OpenRegular /> : props.icon;
  const finalIconPosition = isExternal ? 'after' : props.iconPosition;

  return (
    <Button
      icon={finalIcon}
      appearance={props.appearance ?? 'primary'}
      iconPosition={finalIconPosition}
      data-testid="enhanced-button"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  );
};

export default EnhancedButton;
